import type { IntlShape } from 'react-intl'
import Image from 'components/Common/Image'

export function getStepsHowItWorks(intl: IntlShape) {
  return [
    {
      image: <Image
        style={{ height: 40 }}
        id="tcqw0293hnq17bzcd78d"
        alt={intl.formatMessage({
          id: 'FobSxm4Wfg9Ls5rlPME7',
          defaultMessage: 'Step 1',
          description: 'Alt text for step 1 icon in the Afterpay how it works section',
        })}
        quality="eco"
      />,
      title: intl.formatMessage({
        id: 'TuctdW4jDy9V5aKNTbb-',
        defaultMessage: 'Pay in four instalments over six weeks.',
        description: 'Step 1 title for How it works section on Afterpay landing page',
      }),
      description: intl.formatMessage({
        id: 'Z7S4fZpiaJ0a6uB2oeSh',
        defaultMessage: 'Pay your first instalment at the time of purchase, and the rest every two weeks.',
        description: 'Step 1 description for How it works section on Afterpay landing page',
      }),
    },
    {
      image: <Image
        style={{ height: 40 }}
        id="2ejw6szt8h4fesu9j1s"
        alt={intl.formatMessage({
          id: 'DlRK_0otXeYH-xFpJuSu',
          defaultMessage: 'Step 2',
          description: 'Alt text for step 2 icon in the Afterpay how it works section',
        })}
        quality="eco"
      />,
      title: intl.formatMessage({
        id: 'zCejH_lmDmd_bWAJYml4',
        defaultMessage: 'Enjoy no fees when you pay on time.',
        description: 'Step 2 title for How it works section on Afterpay landing page',
      }),
      description: intl.formatMessage({
        id: 'gzGNeBV_i_P-xWRR5nD_',
        defaultMessage: 'The only fees are late payments but, don’t worry, Afterpay will send regular reminders.',
        description: 'Step 2 description for How it works section on Afterpay landing page',
      }),
    },
    {
      image: <Image
        style={{ height: 40 }}
        id="zndk0xexpwvqcsq6b84"
        alt={intl.formatMessage({
          id: 'E5VeFG5ITryW8jy2x4Ii',
          defaultMessage: 'Step 3',
          description: 'Alt text for step 3 icon in the Afterpay how it works section',
        })}
        quality="eco"
      />,
      title: intl.formatMessage({
        id: 'azSHyL2xhPVHRQCkYKqf',
        defaultMessage: 'Get instant approval in seconds.',
        description: 'Step 3 title for How it works section on Afterpay landing page',
      }),
      description: intl.formatMessage({
        id: 'xIwLrmUsRolIIwg-s2OT',
        defaultMessage: 'Know you’ve been approved almost instantly.',
        description: 'Step 3 description for How it works section on Afterpay landing page',
      }),
    },
  ]
}

export function getStepsBuyNow(intl: IntlShape) {
  return [
    {
      title: '1',
      description: intl.formatMessage({
        id: 'R3eR6R-zlOg5YfHzXj7m',
        defaultMessage: 'Browse your favourite escapes',
        description: 'Step 1 description for Buy now section on Afterpay landing page',
      }),
    },
    {
      title: '2',
      description: intl.formatMessage({
        id: 'rVqUqvwoK1U9hUtvQpeP',
        defaultMessage: 'Instantly create an account and complete your purchase',
        description: 'Step 2 description for Buy now section on Afterpay landing page',
      }),
    },
    {
      title: '3',
      description: intl.formatMessage({
        id: 'FDeZXJY8cyrU1jy-rQ52',
        defaultMessage: 'Choose Afterpay as your payment method',
        description: 'Step 3 description for Buy now section on Afterpay landing page',
      }),
    },
  ]
}
